import { defineComponent as _defineComponent } from 'vue';
import { computed, onMounted } from "vue";
import { useConfig } from "@/composables/config";
import { useJobStore } from "@/stores/jobStore";
import { useRouter } from "vue-router/composables";
import ToolEntryPoints from "@/components/ToolEntryPoints/ToolEntryPoints.vue";
import ToolRecommendation from "../ToolRecommendation.vue";
import ToolSuccessMessage from "./ToolSuccessMessage.vue";
import Webhook from "@/components/Common/Webhook.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolSuccess',
    setup(__props) {
        const { config } = useConfig(true);
        const jobStore = useJobStore();
        const router = useRouter();
        const jobDef = computed(() => responseVal.value.jobDef);
        const jobResponse = computed(() => responseVal.value.jobResponse);
        const responseVal = computed(() => jobStore.getLatestResponse);
        const showRecommendation = computed(() => config.value.enable_tool_recommendations);
        const toolName = computed(() => responseVal.value.toolName);
        /* lifecyle */
        onMounted(() => {
            // no response means that no tool was run in this session i.e. no data in the store
            if (Object.keys(responseVal.value).length === 0) {
                router.push(`/`);
            }
        });
        return { __sfc: true, config, jobStore, router, jobDef, jobResponse, responseVal, showRecommendation, toolName, ToolEntryPoints, ToolRecommendation, ToolSuccessMessage, Webhook };
    }
});
